export default "__VITE_ASSET__Cgj0omfH__"